import { ProfileQuery$data } from '@src/pages/Profile/gql/__generated__/ProfileQuery.graphql'
import { useTranslation } from 'react-i18next'
import StatItem from './StatItem/StatItem'
import React from 'react'
import { StatisticsGrid, StatisticsWrapper } from './ProfileStatistics.styled'

export type StatElementProps = {
  value: string
  title: string
  color?: string
  hideProgress?: boolean
}

export function ProfileStatistics({ profile, wager }: { profile: ProfileQuery$data['profile']; wager: string }) {
  const { t } = useTranslation()

  const insertedAt = new Date(profile.insertedAt)
  const elapsedDays = Math.floor((new Date().getTime() - insertedAt.getTime()) / (1000 * 3600 * 24))

  const votes = profile.votes ?? 0

  const stats: StatElementProps[] = [
    { title: t('profile.statistics.votes', 'Votes'), value: votes.toString() },
    { title: t('profile.statistics.playTime', 'Play time (days)'), value: elapsedDays.toString() },
    {
      title: t('profile.statistics.followers', 'Followers'),
      value: '0',
    },
    { title: t('profile.statistics.wagered', 'Wagered'), value: `$${wager}` },
  ]

  return (
    <StatisticsWrapper>
      <StatisticsGrid>
        {stats.map((stat, i) => (
          <React.Fragment key={i}>
            <StatItem {...stat} />
          </React.Fragment>
        ))}
      </StatisticsGrid>
    </StatisticsWrapper>
  )
}
